<template>
  <div>
    <div class="bannerStyle">
      <img src="@/assets/teambannera.jpg" />
      <img src="@/assets/teambannerb.jpg" />
      <img src="@/assets/teambannerc.jpg" />
    </div>
    <div class="enter" v-if="name == '' && label == '' && imgSrc == ''">
      <p class="p"><el-link href="/" :underline="false">首页</el-link> / 专家团队</p>
      <el-row :gutter="55">
        <el-col :span="8" v-for="(item,index) in resultsData" :key="index">
          <dl class="teamDl" @click="hrefDetail(item)">
            <dt><img :src="item.img" style="height:360px" /></dt>
            <dd>{{item.label}}<b>{{item.name}}</b></dd>
          </dl>
        </el-col>
      </el-row>
      <div class="teampage">
        <el-pagination background :current-page="pageCurrent" :page-size="pageSize" :page-sizes="[3, 6, 9]"
          :total="pageTotal" @current-change="pageChange" @size-change="pageSizeChange"
          layout="total, prev, pager, next,sizes"></el-pagination>
      </div>
    </div>
    <expertDetail v-else @updateParentValue="handleUpdate" :detailName="name" :detailLabel="label" :detailImg="imgSrc">
    </expertDetail>
  </div>
</template>

<script>
  import expertDetail from './expertDetail.vue';
  export default {
    components: {
      expertDetail
    },
    data() {
      return {
        resultsData: [],
        dlList: [{
            label: '创始人',
            name: 'Dr. Sabrina Zhao',
            img: require('@/assets/img.jpg')
          },
          {
            label: '首席合伙人',
            name: '朱翔坤',
            img: require('@/assets/zxk.jpg')
          },
          {
            label: '资深咨询师',
            name: '郎依',
            img: require('@/assets/rys.jpg')
          },
          {
            label: '资深咨询师',
            name: '王亿雯',
            img: require('@/assets/wyws.jpg')
          },
          {
            label: '资深咨询师',
            name: '武清云',
            img: require('@/assets/wqys.jpg')
          },
          {
            label: '资深咨询师',
            name: '张晓菲',
            img: require('@/assets/zxfs.jpg')
          },
          {
            label: '资深咨询师',
            name: '方敏',
            img: require('@/assets/fm.jpg')
          },
          {
            label: '资深咨询师',
            name: '琳晨',
            img: require('@/assets/lcs.jpg')
          },
          {
            label: '资深咨询师',
            name: '俞嘉溦',
            img: require('@/assets/yjc.jpg')
          },
          {
            label: '初级咨询师',
            name: '刘琴琴',
            img: require('@/assets/lqqs.jpg')
          },
          {
            label: '初级咨询师',
            name: '邓伟光',
            img: require('@/assets/dwg.jpg')
          },
          {
            label: '初级咨询师',
            name: '任羽骏',
            img: require('@/assets/ryj.jpg')
          },
          {
            label: '初级咨询师',
            name: '高健峰',
            img: require('@/assets/gjf.jpg')
          },
          {
            label: '初级咨询师',
            name: '卢浩然',
            img: require('@/assets/lhr.jpg')
          }
        ],
        pageCurrent: 1,
        pageSize: 6,
        pageTotal: 0,

        label: "",
        name: "",
        imgSrc: ""
      }
    },

    created() {
      this.getResultsData();
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
      var dataJson = JSON.parse(localStorage.getItem('userJson'));
      if (dataJson != undefined) {
        this.label = dataJson.title;
        this.name = dataJson.label;
        this.imgSrc = dataJson.img;
      }
    },
    methods: {
      // 分页
      pageChange(page) {
        this.pageCurrent = page;
        this.getResultsData();
      },
      pageSizeChange(page) {
        this.pageSize = page;
        this.getResultsData();
      },
      //前端自己分页
      getResultsData: function() {
        // this指向改一下
        var that = this;
        var list = that.dlList;
        this.resultsData = list.filter(
          (item, index) =>
          index < that.pageCurrent * that.pageSize &&
          index >= that.pageSize * (that.pageCurrent - 1)
        ); //根据页数显示相应的内容
        this.pageTotal = list.length;
      },
      hrefDetail(item) {
        this.label = item.label;
        this.name = item.name;
        this.imgSrc = item.img;
      },
      handleUpdate(newValue) {
        this.label = "";
        this.name = "";
        this.imgSrc = "";
      }
    },
  }
</script>
<style scoped>
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }

  .enterImg {
    margin-top: 50px;
  }

  .enterImg img {
    width: 100%;
    display: block;
  }

  .enter {
    width: 950px;
    margin: auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p a {
    font-size: 14px;
  }

  .teamDl {
    cursor: pointer;
  }

  .teamDl dd {
    font-weight: bold;
    font-size: 16px;
    line-height: 54px;
  }

  .teamDl dd b {
    padding-left: 20px;
  }

  .teampage {
    text-align: center;
    margin: 38px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/teamOfExperts.vue